import { message } from "antd";

const config_local = {
    company_name: 'Twinfinity Inc',
    api_base: 'http://localhost:8001/api',
    message_history_limit: 10
};

const config_remote = {
    company_name: 'Twinfinity, Inc',
    api_base: '/api',
    message_history_limit: 10
};

const config = config_remote;

export { config };
